import { render, staticRenderFns } from "./minhand.vue?vue&type=template&id=2da7a420"
import script from "./minhand.vue?vue&type=script&lang=js"
export * from "./minhand.vue?vue&type=script&lang=js"
import style0 from "./minhand.vue?vue&type=style&index=0&id=2da7a420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports